<template id='content'>
	<div class="bg">
		<div class="top">
			<div class="top_c">
				<div>修改下单密码</div>
			</div>
		</div>
		<div class="bottom">
			<div class="b_t">修改下单密码 <span @click="forget">忘记密码，找回点这里！</span></div>
			<div v-show="!isForget" class="b_c">
				<div class="clearfix">
					<div class="b_c_1 b_c_1_" v-for="(stepitem,idx) in steplist" :key="idx">
						<div class="b_c_1_bg" :class="{background:idx==step,background1:idx<step}"></div>
						<div class="b_c_1_c" :class="{background:idx==step,background1:idx<step}">{{stepitem.id+1}}</div>
						<div class="b_c_1_t" :class="{color:idx==0,color1:idx<step}">{{stepitem.text}}</div>
					</div>
				</div>
			</div>
			<div v-show="isForget" class="b_c">
				<div class="clearfix">
					<div class="b_c_1 b_c_1_" v-for="(stepitem,idx) in steplist_" :key="idx">
						<div class="b_c_1_bg" :class="{background:idx==step_,background1:idx<step_}"></div>
						<div class="b_c_1_c" :class="{background:idx==step_,background1:idx<step_}">{{stepitem.id+1}}</div>
						<div class="b_c_1_t" :class="{color:idx==0,color1:idx<step_}">{{stepitem.text}}</div>
					</div>
				</div>
			</div>
			<div>
				<ul v-show="!isForget" class="payPwdUl1">
					<li class="clearfix" v-show="step==0">
						<span class="fl">旧密码：</span>
						<input type="password" maxlength="6" v-model="oldpwd">
					</li>
          <li class="clearfix" v-show="step==1">
						<span class="fl">新密码：</span>
						<input type="password" maxlength="6" v-model="newpwd1">
					</li>
          <li class="clearfix" v-show="step==1">
						<span class="fl">再次输入：</span>
						<input type="password" maxlength="6" v-model="newpwd2">
					</li>
          <li class="clearfix" v-show="step!=2" style="margin-left:80px;">
						<input type="button" @click="submit1(step)" class="one_ulbtn" value="提交">
					</li>
					<li v-show="step==2">
						<div class="box clearfix">
							<img style="width:50px;height:50px;" src="../../assets/img/complete.png" alt="">
							<div style="text-align:center;">
								<img src="" alt="">
							</div>
							<div>
								<span style="color:#757575;">新密码设置成功！5秒后自动<em @click="goto">返回个人中心首页。</em></span>
							</div>
						</div>
					</li>
				</ul>
				<ul v-show="isForget" class="payPwdUl1">
					<li class="clearfix" v-show="step_==0">
						<span class="fl">登录密码：</span>
						<input type="password" maxlength="20" v-model="signInpwd">
					</li>
          <li class="clearfix" v-show="step_==1">
						<span class="fl">新密码：</span>
						<input type="password" maxlength="6" v-model="newpwd1">
					</li>
          <li class="clearfix" v-show="step_==1">
						<span class="fl">再次输入：</span>
						<input type="password" maxlength="6" v-model="newpwd2">
					</li>
          <li class="clearfix" v-show="step_!=2" style="margin-left:80px;">
						<input type="button" @click="submit2(step_)" class="one_ulbtn" value="提交">
					</li>
					<li v-show="step_==2">
						<div class="box clearfix">
							<img style="width:50px;height:50px;" src="../../assets/img/complete.png" alt="">
							<div style="text-align:center;">
								<img src="" alt="">
							</div>
							<div>
								<span style="color:#757575;">新密码设置成功！5秒后自动<em @click="goto">返回个人中心首页。</em></span>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,sha1 } from '../../assets/js/public.js'
import bus from '../../assets/js/eventBus'

export default {
  data () {
    return {
      steplist:[{'id':0,'text':'验证旧密码'},{'id':1,'text':'设置新密码'},{'id':2,'text':'完成'}],
      steplist_:[{'id':0,'text':'验证登录密码'},{'id':1,'text':'设置新密码'},{'id':2,'text':'完成'}],
			step:0,
			step_:0,
			oldpwd:'',
			signInpwd:'',
			newpwd1:'',
			newpwd2:'',
			isForget:false
    }
  },
  mounted:function () {
    var t_=this
    // t_.step=t_.$route.query.step-1
  },
  methods:{
		forget:function(){
			var t_=this
			t_.isForget=true
		},
		goto:function(){
			this.$router.push({path: '/member'});
		},
		submit2:function(n){
			var t_=this
      if(n==0){
        if(t_.signInpwd=='')return t_.$message({
          message:'请输入登录密码',
          center:true,
          type:'warning'
        })
        var data0bj=Qs.stringify({
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          password:sha1(t_.signInpwd)
        })
        axios.post(`${ip}formWorkInterface/isMemberPassword`,data0bj).then(res=>{
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            t_.step_=1
            // t_.signInpwd=''
          }else{
            t_.$message({
              message:res.data.message,
              center:true,
              type:'warning'
            })
          }
        })
      }else if(n==1){
				if(t_.newpwd1==''||t_.newpwd2=='')return t_.$message({
					message:'请输入密码。',
					center:true,
					type:'warning'
				})
				if(t_.newpwd1.length<6||t_.newpwd2.length<6)return t_.$message({
					message:'密码为6位',
					center:true,
					type:'warning'
				})
				if(t_.newpwd1!=t_.newpwd2)return t_.$message({
					message:'密码不一致。',
					center:true,
					type:'warning'
				})
				var data0bj={
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          newPassword:sha1(t_.newpwd1)
				}
				if(t_.oldpwd){
					data0bj.type=2
					data0bj.password=sha1(t_.oldpwd)
				}
				if(t_.signInpwd){
					data0bj.type=1
					data0bj.password=sha1(t_.signInpwd)
				}
				data0bj=Qs.stringify(data0bj)
        axios.post(`${ip}formWorkInterface/updatePassword`,data0bj).then(res=>{
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
						t_.$message({
							message:res.data.result.member,
							center:true,
							type:'success'
						})
						t_.step_=2
						t_.newpwd1=''
						t_.newpwd2=''
						setTimeout(function(){
							t_.goto()
						},5000,t_)
					}else{
						t_.$message({
							message:'设置新下单密码失败。',
							center:true,
							type:'warning'
						})
					}
        })
			}
		},
    submit1:function(n){
      var t_=this
      if(n==0){
        if(t_.oldpwd=='')return t_.$message({
          message:'请输入旧下单密码',
          center:true,
          type:'warning'
        })
        var data0bj=Qs.stringify({
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          password:sha1(t_.oldpwd)
        })
        axios.post(`${ip}formWorkInterface/isPayPassword`,data0bj).then(res=>{
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            t_.step=1
            // t_.oldpwd=''
          }else{
            t_.$message({
              message:res.data.message,
              center:true,
              type:'warning'
            })
          }
        })
      }else if(n==1){
				if(t_.newpwd1==''||t_.newpwd2=='')return t_.$message({
					message:'请输入密码。',
					center:true,
					type:'warning'
				})
				if(t_.newpwd1.length<6||t_.newpwd2.length<6)return t_.$message({
					message:'密码为6位',
					center:true,
					type:'warning'
				})
				if(t_.newpwd1!=t_.newpwd2)return t_.$message({
					message:'密码不一致。',
					center:true,
					type:'warning'
				})
				var data0bj={
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          newPassword:sha1(t_.newpwd1)
				}
				if(t_.oldpwd){
					data0bj.type=2
					data0bj.password=sha1(t_.oldpwd)
				}
				if(t_.signInpwd){
					data0bj.type=1
					data0bj.password=sha1(t_.signInpwd)
				}
				data0bj=Qs.stringify(data0bj)
        axios.post(`${ip}formWorkInterface/updatePassword`,data0bj).then(res=>{
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
						t_.$message({
							message:res.data.result.member,
							center:true,
							type:'success'
						})
						t_.step=2
						t_.newpwd1=''
						t_.newpwd2=''
						setTimeout(function(){
							t_.goto()
						},5000,t_)
					}else{
						t_.$message({
							message:'设置新下单密码失败。',
							center:true,
							type:'warning'
						})
					}
        })
			}
    }
  }
}
</script>

<style>
  html,body{
    height: 100%;
  }
	.clearfix {
		overflow: auto;
		_height: 1%;
	}
	.fl{
		float: left;
  }
  input,fieldset,textarea{
    margin:0;
    padding:0;
    background:none;
    border:none;
    vertical-align:top;	
    resize:none;
  }
	.bg{
		background: #f5f5f5;
		height: 100%;
	}
	.top{
		background: #fff;
		height: 116px;
		border-bottom: 3px solid #ff2c4c;
	}
	.top_c{
		width: 990px;
		height: 116px;
		margin: 0 auto;
	}
	.top_c div{
		font-size: 24px;
		color:#2d2d2d;
		margin-left: 20px;
		line-height: 96px;
	}
	.bottom{
		width: 990px;
		height: 530px;
		background: #fff;
		margin: 0 auto;
	}
	.b_t{
		height: 44px;
		padding: 24px 0 0 21px;
		color:#666;
		font-weight: 900;
	}
	.b_t span{
		color:red;
		cursor: pointer;
	}
	.b_c{
		width: 634px;
		margin: 0 auto;
		overflow: hidden;
	}
	.b_c_1{
		height: 40px;
		position: relative;
		float: left;
		overflow: hidden;
	}
	.b_c_1_{
		width: 33%;
	}
	.b_c_1_bg{
		width: 100%;
		height: 5px;
		background: #cdcdcd;
		position: absolute;
		top: 10px;
	}
	.b_c_1_c{
		width: 23px;
		height: 23px;
		border-radius: 50%;
		background: #cdcdcd;
		color: #fff;
		text-align: center;
		line-height: 23px;
		margin: 0 auto;
		position: relative;
	}
	.b_c_1_t{
		color:#666;
		text-align: center;
		margin-top: 1px;
	}
	.background{
		background: #7abd54;
	}
	.color{
		color:#7abd54;
	}
	.color1{
		color:#7abd54;
	}
	.background1{
		background:#cbedb7;
	}
	.payPwdUl1{
		margin-top: 44px;
		margin-left: 357px;
	}
	.payPwdUl1 li{
		margin-bottom: 21px;
	}
	.payPwdUl1 li span{
    line-height: 36px;
    width: 80px;
    text-align: center;
	}
	.payPwdUl1 input{
		width: 150px;
		height: 34px;
		border: 1px solid #cdcdcd;
		padding-left: 5px;
	}
	.payPwdUl1 i{
		display: inline-block;
		width: 60px;
		height: 34px;
		border: 1px solid #cdcdcd;
		border-radius: 10px;
		margin-left: 21px;
		text-align: center;
		line-height: 36px;
		color:#dd2c3a;
		font-style: normal;
	}
	.payPwdUl1 b{
		font-weight: 100;
		cursor: pointer;
	}
	.payPwdUl1 .one_ulbtn{
		width: 62px;
		height: 32px;
		border: 0;
		border-radius: 10px;
		background:#dd2c3a;
		text-align: center;
		line-height: 32px;
		color: #fff;	
	}
	.payPwdUl1 .box{
		text-align: center;
		width: 285px;
	}
	.payPwdUl1 .box span{
		line-height: 23px;
		margin-left: 25px;
	}
	.payPwdUl1 em{
		cursor: pointer;
		color:red;
	}
</style>


// WEBPACK FOOTER //
// src/components/member/payPassword.vue